export default __webpack_public_path__ + "524c19a.png";